// Shared, monotonic instance-id source. Kept in its own tiny module so both the
// minimal boot entry (init) and the main entry (initialise / TimumBooking) draw
// from ONE counter — ids stay globally unique across all embed paths — without
// the boot entry having to pull in the main entry's heavier graph.
let counter = 0;

/** e.g. nextInstanceId('bookingjs') -> 'bookingjs_0', 'bookingjs_1', … */
export function nextInstanceId(prefix) {
  return `${prefix}_${counter++}`;
}
